// DID-document resolution helpers. Canonical implementation lives in
// @streamplace/core; this keeps the historical import path working.
export {
  getBlob,
  getPDSServiceEndpoint,
  resolveDIDDocument,
  type DIDDocument,
} from "@streamplace/core";
